<footer>
    <div class="footer-info-strip mog_ftr" *ngIf="!isDisableFormOnContactusPage">
        <div
            [ngClass]="[currentUrl === '/' ||  currentUrl === '/pages/contact-us' ? 'container-xl' : 'container-fluid px-50']">
            <div class="row">
                <div class="col-lg-7">
                    <div class="row qck-lnks">
                        <img src="./assets/images/Tender_Shark_Powered_by_Credlix.svg" width="182"   loading="lazy" alt="">
                        <span class="text-white contact-us-heading">Contact Us</span>
                        <div class="col-lg-6 ">
                            <ul class="ps-0">
                                <li>
                                    <p class="text-white d-flex">
                                        <i class="sprite-img-header-footer location-pin"></i>
                                        <span>D-188, D Block, Sector 10, Noida, Uttar Pradesh
                                            <br> Pin: 201301 </span>
                                    </p>
                                </li>
                                <li>
                                    <a class="text-white d-flex" title="Mail us at our Official Mail ID"
                                        href="mailto:care&#64;tendershark.com">
                                        <i class="sprite-img-header-footer email-white"></i>
                                        <span>care&#64;tendershark.com</span>
                                    </a>
                                    <a class="text-white d-flex" title="Mail us at our Official Mail ID"
                                        href="mailto:legal&#64;tendershark.com">
                                        <i class="sprite-img-header-footer email-white"></i>
                                        <span>legal&#64;tendershark.com</span>
                                    </a>
                                </li>
                            </ul>
                            <div class="social-media">
                                <a href="https://www.facebook.com/people/TenderShark/61562274689255/" target="_blank"
                                    class="social-icon facebook" title="Facebook">
                                    <i class="sprite-img-header-footer  social-media-icons facebook-icon"></i>
                                </a>
                                <a href="https://www.instagram.com/tender__shark/" target="_blank"
                                    class="social-icon instagram" title="Instagram">
                                    <i class="sprite-img-header-footer  social-media-icons instagram-icon"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/tendershark/" target="_blank"
                                    class="social-icon linkedin" title="Linkedin">
                                    <i class="sprite-img-header-footer  social-media-icons linkdin-icon"></i>
                                </a>
                                <a href="https://x.com/tender_shark" target="_blank" class="social-icon twitter"
                                    title="Twitter">
                                    <i class="sprite-img-header-footer  social-media-icons twitter-icon"></i>
                                </a>


                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-tender-list-section">
        <!--Main Footer Start From Here-->
        <!-- <div class="mog_ftr footer-bg-2"> -->
        <div class="mog_ftr footer-bg-2" [lazyLoad]="'https://d1tiqtcifmy0l7.cloudfront.net/prod/icons/Map.svg'">
            <div
                [ngClass]="[currentUrl === '/' ||  currentUrl === '/pages/contact-us' ? 'container-xl' : 'container-fluid px-50']">
                <div class="row mx-0 footer-quick-links">
                    <!--Contact Us End Here-->
                    <div class="col-lg-8  d-flex flex-column ">
                        <div class="row">
                            <div class="col-lg-4 col-6 ps-0 qck-lnks footer-address">
                                <span class="mb-3 information-heading">Company Information</span>
                                <ul class="ps-0 quick-list">
                                    <li>
                                        <a href="/pages/about-us" target="_blank"
                                            title="Know More about TenderShark">About Us</a>
                                    </li>
                                    <li>
                                        <a href="/pages/contact-us" target="_blank" title="Get in touch with us">Contact
                                            Us</a>
                                    </li>
                                    <li>
                                        <a href="/blogs" target="_blank" title="Get in touch with us">Blogs</a>
                                    </li>
                                    <li>
                                        <a href="/all-tenders/authorities" target="_blank"
                                            title="Get in touch with us">Tender by Authority</a>
                                    </li>
                                    <li>
                                        <a href="/all-tenders/keywords" target="_blank"
                                            title="Get in touch with us">Tender by Keyword</a>
                                    </li>
                                    <li>
                                        <a href="/all-tenders/states" target="_blank"
                                            title="Get in touch with us">Tender by States</a>
                                    </li>
                                    <li>
                                        <a href="/all-tenders/cities" target="_blank"
                                            title="Get in touch with us">Tender by Cities</a>
                                    </li>
                                    <li>
                                        <a href="/pages/download-tender-mobile-app" target="_blank"
                                            title="Get in touch with us">Download TenderShark Mobile App</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 col-6 qck-lnks">
                                <span class=" mb-3 information-heading">Policy Information</span>
                                <ul class="ps-0 quick-list">
                                    <li>
                                        <a href="/pages/terms-and-conditions" target="_blank"
                                            title="Know the Terms & Conditions Before Applying">
                                            Terms and Conditions
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/pages/privacy-policy" target="_blank" title="Privacy Policy">Privacy
                                            Policy</a>
                                    </li>
                                    <li>
                                        <a href="/pages/copyright" target="_blank" title="Copyright">Copyright</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-4 col-6 qck-lnks">
                                <span class=" mb-3 information-heading">Miscellaneous</span>
                                <ul class="ps-0 quick-list">
                                    <li>
                                        <a href="https://www.moglix.com/" target="_blank" title="Bulk Enquiry">
                                            Moglix
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.moglix.com/rfq" target="_blank" title="Bulk Enquiry">
                                            Bulk Enquiry
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://business.moglix.com" target="_blank" title="Moglix Business">
                                            Moglix Business</a>
                                    </li>
                                    <li>
                                        <a href="https://supplier.moglix.com/" target="_blank"
                                            title="Supplier Central">Supplier Central</a>
                                    </li>
                                    <li>
                                        <a href="https://www.credlix.com/" target="_blank" title="Credlix">Credlix</a>
                                    </li>
                                    <li>
                                        <a href="https://www.digimro.com/" target="_blank" title="DigiMRO">DigiMRO</a>
                                    </li>
                                    <li>
                                        <a href="https://zoglix.com/" target="_blank" title="Zoglix">Zoglix</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-lg-7 ps-0">
                                <p class="copyright-msg">
                                    &copy;2025 TenderShark. All Rights Reserved
                                </p>
                            </div>
                        </div>
                    </div>
                    <!--Contact Us Form Start From Here-->
                    <div class="col-lg-4  position-relative">
                        <div class="card footer-card mb-40" *ngIf="!isDisableFormOnContactusPage">
                            <div class="card-header border-0 p-0">
                                <span class="form-heading" title="Get In Touch With Us">Get In Touch With Us </span>
                            </div>
                            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                                <div class="card-body p-0">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="mb-4 position-relative">
                                                <input placeholder="Name*" formControlName="name" class="form-control">
                                                <div class="text-danger validation-msg position-absolute"
                                                    *ngIf="isSubmitted && formControls?.name?.errors">
                                                    <div *ngIf="formControls?.name?.errors?.required">
                                                        <small>Name is required</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="mb-4 position-relative">
                                                <input id="email" class="form-control" placeholder="Email ID*"
                                                    formControlName="email">
                                                <div class="text-danger validation-msg position-absolute"
                                                    *ngIf="isSubmitted && formControls?.email?.errors">
                                                    <div *ngIf="formControls?.email?.errors?.required">
                                                        <small>Email address is required</small>
                                                    </div>
                                                    <div *ngIf="formControls?.email?.errors?.pattern">
                                                        <small>Please enter a valid email address</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12">
                                            <div class="mb-4 position-relative">
                                                <input id="gstNum" class="form-control" placeholder="GST Number*"
                                                    formControlName="gstNum">
                                                <div class="text-danger validation-msg position-absolute"
                                                    *ngIf="isSubmitted && formControls?.gstNum?.errors">
                                                    <div *ngIf="formControls?.gstNum?.errors?.required">
                                                        <small>GST number is required</small>
                                                    </div>
                                                    <div *ngIf="formControls?.gstNum?.errors?.pattern">
                                                        <small>Please enter a valid GST ID</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12">
                                            <div class="mb-4 position-relative">
                                                <input class="form-control" placeholder="Contact No*"
                                                    formControlName="phone">
                                                <div class="text-danger validation-msg position-absolute"
                                                    *ngIf="isSubmitted && formControls?.phone?.errors">
                                                    <div *ngIf="formControls?.phone?.errors?.required">
                                                        <small>Contact number is required</small>
                                                    </div>
                                                    <div *ngIf="formControls?.phone?.errors?.pattern">
                                                        <small>Please enter a valid phone no.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12">
                                            <div class="mb-4 position-relative">
                                                <textarea rows="5" placeholder="Other Information"
                                                    formControlName="description" class="form-control"></textarea>
                                                <div class="text-danger validation-msg position-absolute"
                                                    *ngIf="isSubmitted && formControls?.description?.errors">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mb-3 footer-form-submit">
                                        <button class="btn red-btn " type="submit"> GET IN TOUCH </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Main Footer End Here-->
    </div>
</footer>